import 'bootstrap';

// protect against double loading (caused by lodash-es for some reason)
if (!window.mainIndexLoaded) {
    window.mainIndexLoaded = true;

    // load for all normal pages
    if (document.querySelector('body.Page')) {
        import('./color-mode-switcher').then();
        import('./scroll-hide').then();
        import('./mobile-nav').then();
        // import('./vh').then();
        // import('./search-helper').then();
        // import('./dialog').then();
    }
    
    // animate-on-visible
    if (document.querySelector('[data-animate-on-visible]')) {
        import('./animate-on-visible').then();
    }
    
    // counterup-helper
    if (document.querySelector('[data-counterup]')) {
        import('./counterup-helper').then();
    }
    
    // // focuspoint-helper
    // if (document.querySelector('[data-focus-x]')) {
    //     import('./focuspoint-helper').then();
    // }
}    
